<div *ngIf="loading" class="loading-container">
	<p>{{ vps.isMobile ? 'Lade Punkte...' : 'Lade Punkte und generiere PDF-Vorschau...' }}</p>
</div>

<div *ngIf="!loading && bps.length === 0" class="no-points">
	<p>Keine Punkte zum Drucken ausgewählt.</p>
	<button class="btn btn-primary" (click)="onClose()">Zurück zur Karte</button>
</div>

<div *ngIf="!loading && bps.length > 0" class="pdf-view-container">
	<div class="print-controls no-print">
		<span>{{ bps.length }} Punkt(e)</span>
		<button class="btn btn-primary" (click)="onSavePdf()" [disabled]="pdfExporting">
			<i class="bi" [ngClass]="pdfExporting ? 'bi-hourglass-split' : 'bi-file-pdf'"></i>
			{{ pdfExporting ? 'Exportiere...' : 'Als PDF speichern' }}
		</button>
		<button class="btn btn-outline-secondary" (click)="onClose()" [disabled]="pdfExporting">
			<i class="bi bi-arrow-left"></i> Zurück
		</button>
	</div>

	<!-- PDF-Vorschau nur auf Desktop (funktioniert nicht auf Android) -->
	<ng-container *ngIf="!vps.isMobile">
		<div class="pdf-preview-container" *ngIf="pdfPreviewUrl">
			<object [data]="pdfPreviewUrl" type="application/pdf" class="pdf-preview">
				<div class="pdf-fallback">
					<p>Vorschau auf mobilen Geräten nicht verfügbar.</p>
				</div>
			</object>
		</div>
		<div class="pdf-loading" *ngIf="!pdfPreviewUrl">
			<p>Generiere PDF-Vorschau...</p>
		</div>
	</ng-container>

	<!-- Mobil: Hinweis statt Vorschau -->
	<div class="mobile-hint" *ngIf="vps.isMobile">
		<p>Vorschau auf mobilen Geräten nicht verfügbar.</p>
	</div>
</div>
